import { BillingProvider } from './context/BillingContext'
import { UIProvider } from './context/UIContext'
import TeamBillingPage from './TeamBillingPage'

interface TeamBillingTableProps {
  teamId: string
  canEdit: boolean
  /** The roster (season) the Registration tab's Season picker selected. */
  rosterId: string | null
}

const TeamBillingTable = ({
  teamId,
  canEdit,
  rosterId,
}: TeamBillingTableProps) => (
  <BillingProvider teamId={teamId}>
    <UIProvider>
      <TeamBillingPage teamId={teamId} canEdit={canEdit} rosterId={rosterId} />
    </UIProvider>
  </BillingProvider>
)

export default TeamBillingTable
